module.exports = __webpack_public_path__ + "img/metallic_texture.aaf19716.jpg";